import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import Select from "react-select";
import { alternativeCleanAllSelectedWithoutList, cleanAlternativesPaginatedS } from '../../app/actions/alternativeActions';
import { cleanExperiencesPaginatedS, experienceCleanAllSelectedWithoutList } from '../../app/actions/experienceActions';
import { cleanInnovationsPaginatedS, innovationCleanAllSelectedWithoutList } from '../../app/actions/innovationActions';
import { assistanceCleanAllSelectedWithoutList, cleanAssistancesPaginatedS } from '../../app/actions/assistanceActions';
import { cleanVisionsPaginatedS } from '../../app/actions/visionActions';
import { cleanRegulationsPaginatedS } from '../../app/actions/regulationActions';
import { cleanFinancialsPaginatedS, financialCleanAllSelectedWithoutList } from '../../app/actions/financialActions';
import { cleanSearchText, setSearchText, startRegisterSearchInfo } from '../../app/actions/searchInfoActions';
import { cleanTechnologiesPaginatedS, technologyCleanAllSelectedWithoutList } from '../../app/actions/technologyActions';
import { cleanSearchParamsNoModule, setPreviousSearchParams } from '../../app/actions/searchHistoryActions';
import { dispatchModuleSearch } from '../../app/helpers/moduleSearch.helper';
import { startLoadingCatalogCiiuByParentLocal } from '../../app/actions/catalogCiiuActions';
import { startLoadingCatalogsByGroupVision } from '../../app/actions/catalogActions';
import { isSemanticSearchHelpLegendEnabled, isSemanticSearchHelpPopupEnabled } from '../../app/helpers/semanticSearchConfigHelper';

const EXCLUDED_CODES = ['V', 'W'];

const L2SearchTextComponent = ({ searchTextState, setSearchTextState, moduleSelected, setModuleSelected, catalogCiiuLevel1Selected, setCatalogCiiuLevel1Selected, setExistDataToShow, setCatalogsToFilter, setIndicatorsToFilter, setWasSearched, setLastSearchSubmitted, itemsPerPage, setItemsPerPage, groupVisionSelected, setGroupVisionSelected, concernSelected, setConcernSelected }) => {

    const dispatch = useDispatch();

    const { catalogModules } =
        useSelector((state) => state.catalogModule);

    const { listCatalogCiiusLevel1 } =
        useSelector((state) => state.catalogCiiu);

    const { isLoadingTechnologies = false } = useSelector((state) => state.technology);
    const { isLoadingAlternatives = false } = useSelector((state) => state.alternative);
    const { isLoadingExperiences = false } = useSelector((state) => state.experience);
    const { isLoadingInnovations = false } = useSelector((state) => state.innovation);
    const { isLoadingAssistances = false } = useSelector((state) => state.assistance);
    const { isLoadingFinancials = false } = useSelector((state) => state.financial);
    const { isLoadingVisions = false } = useSelector((state) => state.vision);
    const { isLoadingRegulations = false } = useSelector((state) => state.regulation);


    const { user } = useSelector((state) => state.auth);

    const { listGroups, listConcernsGroup } = useSelector((state) => state.catalog);

    const {
        searchModuleTechnologyEnabled,
        searchModuleAlternativeEnabled,
        searchModuleExperienceEnabled,
        searchModuleInnovationEnabled,
        searchModuleAssistanceEnabled,
        searchModuleFinancialEnabled,
        searchModuleVisionEnabled,
        searchModuleRegulationEnabled

    } = useSelector((state) => state.configuration);

    const helpPopupEnabled = useSelector((state) => isSemanticSearchHelpPopupEnabled(state.configuration));
    const helpLegendEnabled = useSelector((state) => isSemanticSearchHelpLegendEnabled(state.configuration));
    const [searchHelpVisible, setSearchHelpVisible] = useState(false);
    const [searchHelpOpen, setSearchHelpOpen] = useState(false);

    //Loading
    const isLoading = !!(
        isLoadingTechnologies ||
        isLoadingAlternatives ||
        isLoadingExperiences ||
        isLoadingInnovations ||
        isLoadingAssistances ||
        isLoadingFinancials ||
        isLoadingVisions ||
        isLoadingRegulations
    );

    useEffect(() => {
        if (catalogModules && catalogModules.length > 0 && !moduleSelected) {
            setModuleSelected(catalogModules[0]);
        }
    }, [catalogModules, moduleSelected, setModuleSelected]);

    const { t } = useTranslation();

    const handleChangeValues = (event, type) => {

        if (type === 'input') {
            event.preventDefault();
            localStorage.setItem("searchTextLocal", event.target.value);
            setSearchTextState(event.target.value);

            if (event.target.value !== "") {
                dispatch(setSearchText(event.target.value));
            } else {
                dispatch(cleanSearchText());
            }
        }

        if (type === 'select') {
            if (event != null) {
                localStorage.setItem("searchTextLocal", event && event.description);
                setSearchTextState(event.description);

                setConcernSelected(event);
            }
            else {
                setConcernSelected("");
                dispatch(cleanSearchText);
            }
        }

    }

    const handleGetTechnologies = (e) => {
        // 1. Evitar propagación y colisiones
        if (e) { e.preventDefault(); e.stopPropagation(); }
        setSearchHelpVisible(false);
        if (isLoading) return;

        const catalogToFilter = []; // O la lógica que uses para llenar filtros

        // 2. Registro de auditoría y parámetros previos (Mantenemos tu lógica de negocio)
        dispatch(startRegisterSearchInfo({
            text_search: searchTextState,
            indicators: [],
            filters: catalogToFilter,
            catalogmodule_id: moduleSelected.id,
            user_id: user.user_id,
            deleted: false
        }));

        

        //JT PAGE Modificar este metodo JT2
        dispatch(setPreviousSearchParams({
            searchText: searchTextState,
            page: 0,
            size: itemsPerPage,
            catalogsToFilter: catalogToFilter,
            indicatorsToFilter: [],
            catalogModule: moduleSelected || {},
            catalogCiiuLevel1: catalogCiiuLevel1Selected || {},
            groupVision: groupVisionSelected || {},
            concern: concernSelected || {}
            
        }));

        // 3. Preparar datos para el Helper Genérico JT verificar
        const params = {
            searchText: searchTextState,
            moduleKey: moduleSelected?.key,
            page: 0,
            itemsPerPage: itemsPerPage,
            catalogToFilter: catalogToFilter,
            indicatorToFilter: [],
            //codeCiiuLevel1: catalogCiiuLevel1Selected?.code || {},
            //codeCiiuLevel1: catalogCiiuLevel1Selected?.code ,
            codeCiiuLevel1: catalogCiiuLevel1Selected?.code || null,
        };

        // Agrupamos las variables de entorno necesarias
        const envVars = {
            searchModuleTechnologyEnabled,
            searchModuleAlternativeEnabled,
            searchModuleExperienceEnabled,
            searchModuleInnovationEnabled,
            searchModuleAssistanceEnabled,
            searchModuleFinancialEnabled,
            searchModuleRegulationEnabled,
            searchModuleVisionEnabled
        };

        // 4. Ejecutar el Helper
        // wasSearched será true si se disparó una acción, o false si se ejecutó la limpieza
        const wasSearched = dispatchModuleSearch(dispatch, params, envVars);

        cleanComparisonFlags();

        // 5. Actualizar estados locales de la UI
        setWasSearched(wasSearched);

        if (wasSearched) {
            setLastSearchSubmitted(searchTextState);
        } else {
            // Si no se buscó (limpieza), reseteamos el input local
            setSearchTextState("");
        }
    };

    const cleanComparisonFlags = () => {
        dispatch(technologyCleanAllSelectedWithoutList());
        dispatch(alternativeCleanAllSelectedWithoutList());
        dispatch(experienceCleanAllSelectedWithoutList());
        dispatch(innovationCleanAllSelectedWithoutList());
        dispatch(financialCleanAllSelectedWithoutList());
        dispatch(assistanceCleanAllSelectedWithoutList());

    }

    const customStyles = {
        option: (provided, state) => ({
            ...provided,

            fontSize: state.selectProps.myFontSize,
            fontWeight: state.selectProps.myFontWeight,
            color: state.isDisabled ? '#8b919a' : state.selectProps.myColor,
            opacity: state.isDisabled ? 0.45 : 1,
            cursor: state.isDisabled ? 'not-allowed' : 'default',
            backgroundColor: state.isDisabled ? '#f1f3f5' : provided.backgroundColor,

        }),

        singleValue: (provided, state) => ({
            ...provided,

            fontSize: state.selectProps.myFontSize,
            fontWeight: state.selectProps.myFontWeight,
            color: "inherit"
        }),
        control: base => ({
            ...base,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '50px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),

        placeholder: (provided, state) => ({
            ...provided,

        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '50px',

        }),

        clearIndicator: (provided, state) => ({
            ...provided,

            display: 'none'
        }),

        dropdownIndicator: (provided, state) => ({
            ...provided,

            color: "inherit"
        }),

    };

    const customStylesConcern = {
        option: (provided, state) => ({
            ...provided,
            fontSize: state.selectProps.myFontSize,
            fontWeight: state.selectProps.myFontWeight,
            color: state.isDisabled ? '#8b919a' : state.selectProps.myColor,
            opacity: state.isDisabled ? 0.45 : 1,
            cursor: state.isDisabled ? 'not-allowed' : 'default',
            backgroundColor: state.isDisabled ? '#f1f3f5' : provided.backgroundColor,
        }),

        singleValue: (provided, state) => ({
            ...provided,

            fontSize: state.selectProps.myFontSize,
            fontWeight: state.selectProps.myFontWeight,
            color: "inherit"
        }),
        control: base => ({
            ...base,
        }),

        valueContainer: (provided, state) => ({
            ...provided,

            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        placeholder: (provided, state) => ({
            ...provided,
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,

        }),

        clearIndicator: (provided, state) => ({
            ...provided,

        }),

        dropdownIndicator: (provided, state) => ({
            ...provided,

            color: "inherit"
        }),

    };

    const handleChangeModule = (event) => {
        //console.log("1111, FFFF", event);

        if (event && event != null) {

            setSearchTextState("");
            dispatch(cleanSearchText());

            dispatch(cleanTechnologiesPaginatedS());
            dispatch(cleanAlternativesPaginatedS());
            dispatch(cleanExperiencesPaginatedS());
            dispatch(cleanInnovationsPaginatedS());
            dispatch(cleanAssistancesPaginatedS());
            dispatch(cleanFinancialsPaginatedS());
            dispatch(cleanRegulationsPaginatedS());
            dispatch(cleanVisionsPaginatedS());

            setConcernSelected("");
            setGroupVisionSelected("");

            //Actualizamos el estado del módulo seleccionado 
            //Aqui se limpia tambien el modulo
            //dispatch(cleanSearchParams());  
            dispatch(cleanSearchParamsNoModule())

            // 1. Siempre reseteamos los flags de búsqueda primero
            setWasSearched(false);
            setLastSearchSubmitted("");

            // 2. Luego actualizamos el módulo
            setModuleSelected(event);

            //Reset Filters
            setCatalogsToFilter([]);
            setIndicatorsToFilter([]);

            //CatalogCiiuLevel1
            setCatalogCiiuLevel1Selected(null);

            //JT PAGE
            dispatch(setPreviousSearchParams({
                searchText: '',
                page: 0,
                size: itemsPerPage,
                catalogsToFilter: [],
                indicatorsToFilter: [],
                catalogModule: event || {},
                catalogCiiuLevel1: {},
                groupVision: {},
            }));
        } else {
            setModuleSelected(null);
        }
    }

    const handleChangeCatalogCiiuLevel1 = (event) => {
        //console.log("1111, FFFF", event);
        //El event to send es 
        //console.log("handleChangeCatalogCiiuLevel1 event", event);

        if (event && event != null) {
            //1 seteo el nuevo estdo del catalogo ciiu
            setCatalogCiiuLevel1Selected(event);

            //2 Reseteamos el texto de búsqueda local y global
            setSearchTextState("");
            dispatch(cleanSearchText());

            //3 Limpiamos los resultados de búsqueda en el store para todas las categorías
            dispatch(cleanTechnologiesPaginatedS());
            dispatch(cleanAlternativesPaginatedS());
            dispatch(cleanExperiencesPaginatedS());
            dispatch(cleanInnovationsPaginatedS());
            dispatch(cleanAssistancesPaginatedS());
            dispatch(cleanFinancialsPaginatedS());
            dispatch(cleanRegulationsPaginatedS());
            dispatch(cleanVisionsPaginatedS());

            setConcernSelected("");


            //4 Siempre reseteamos los flags de búsqueda primero
            setWasSearched(false);
            setLastSearchSubmitted("");

            //Reset Filters
            setCatalogsToFilter([]);
            setIndicatorsToFilter([]);

            //Filtar solo los de nivel 2 del ciiu de nivel uno seleccionado
            dispatch(startLoadingCatalogCiiuByParentLocal(event.id, 2));

            //JT PAGE
            dispatch(setPreviousSearchParams({
                searchText: '',
                page: 0,
                size: itemsPerPage,
                catalogsToFilter: [],
                indicatorsToFilter: [],
                catalogModule: moduleSelected || {},
                catalogCiiuLevel1: event || {},
                groupVision: groupVisionSelected || {}
            }));

        } else {
            setCatalogCiiuLevel1Selected(null);
        }
    }

    const handleChangeGroupVision = (event) => {
        //console.log("1111, FFFF", event);
        //El event to send es 
        //console.log("handleChangeGroupVision event", event);

        if (event && event != null) {
            //1 seteo el nuevo estdo del catalogo ciiu
            setGroupVisionSelected(event);

            //
            dispatch(startLoadingCatalogsByGroupVision(event.id));

            //2 Reseteamos el texto de búsqueda local y global
            setSearchTextState("");
            dispatch(cleanSearchText());

            //3 Limpiamos los resultados de búsqueda en el store para todas las categorías
            dispatch(cleanTechnologiesPaginatedS());
            dispatch(cleanAlternativesPaginatedS());
            dispatch(cleanExperiencesPaginatedS());
            dispatch(cleanInnovationsPaginatedS());
            dispatch(cleanAssistancesPaginatedS());
            dispatch(cleanFinancialsPaginatedS());
            dispatch(cleanRegulationsPaginatedS());
            dispatch(cleanVisionsPaginatedS());

            setConcernSelected("");


            //4 Siempre reseteamos los flags de búsqueda primero
            setWasSearched(false);
            setLastSearchSubmitted("");

            //Reset Filters
            setCatalogsToFilter([]);
            setIndicatorsToFilter([]);

            //Filtar solo los de nivel 2 del ciiu de nivel uno seleccionado
            dispatch(startLoadingCatalogCiiuByParentLocal(event.id, 2));

            //JT PAGE
            dispatch(setPreviousSearchParams({
                searchText: '',
                page: 0,
                size: itemsPerPage,
                catalogsToFilter: [],
                indicatorsToFilter: [],
                catalogModule: moduleSelected || {},
                catalogCiiuLevel1: catalogCiiuLevel1Selected || {},
                groupVision: event || {},
            }));

        } else {
            setGroupVisionSelected(null);
        }
    }

    //console.log("1111, JT, listCatalogCiiusLevel1", listCatalogCiiusLevel1);
    //console.log("1111, listGroups", listGroups);
    //console.log("1111, groupVisionSelected", groupVisionSelected);
    //console.log("1111, listConcernsGroup", listConcernsGroup);

    return (
        <div className="container">
            <form onSubmit={handleGetTechnologies} noValidate>
                <div className="row">
                    <div className="col-md-3" style={{ paddingRight: '0' }}>
                        <Select
                            styles={customStyles}
                            myFontSize="1em"
                            myFontWeight="bold"
                            onChange={(event) => handleChangeModule(event)}
                            classNamePrefix="select-module"
                            name="modules"
                            inputId="modules"
                            value={moduleSelected}
                            options={catalogModules}
                            //getOptionLabel={(option) => `${option.description}`}
                            getOptionLabel={(option) => `${t(`general.component-search-${option.key}`)}`}
                            getOptionValue={(option) => `${option.id}`}
                            isClearable={true}
                            isSearchable={true}
                            placeholder="Seleccione un Módulo"
                            className="basic-single"
                        />
                    </div>

                    <div className="col-md-3" style={{ paddingRight: '0' }}>
                        {moduleSelected && moduleSelected.key !== 'vision' ?
                            (<Select
                                styles={customStyles}
                                myFontSize="1em"
                                myFontWeight="bold"
                                onChange={(event) => handleChangeCatalogCiiuLevel1(event)}
                                classNamePrefix="select-catalog-ciiu-level1"
                                name="catalogCiiuLevel1"
                                inputId="catalogCiiuLevel1"
                                value={catalogCiiuLevel1Selected}
                                //options={listCatalogCiiusLevel1}
                                options={listCatalogCiiusLevel1.filter(
                                    (option) => !EXCLUDED_CODES.includes(option.code)
                                )}
                                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                                //getOptionLabel={(option) => `${t(`general.component-search-${option.key}`)}`}
                                getOptionValue={(option) => `${option.id}`}
                                isClearable={true}
                                isSearchable={true}
                                placeholder="Seleccione un Sector de Producción (CIIU)"
                                className="basic-single"
                            />) : (
                                <Select
                                styles={customStyles}
                                myFontSize="1em"
                                myFontWeight="bold"
                                onChange={(event) => handleChangeGroupVision(event)}
                                classNamePrefix="select-catalog-ciiu-level1"
                                name="groupVision"
                                inputId="groupVision"
                                value={groupVisionSelected}
                                //options={listGroups}
                                options={Array.isArray(listGroups) ? [...listGroups].sort((a, b) => a.id - b.id) : []}
                                //options={[...listGroups].sort((a, b) => a.id - b.id)}
                                isOptionDisabled={(option) => option.has_vision === false}
                                getOptionLabel={(option) => `${option.name}`}
                                //getOptionLabel={(option) => `${t(`general.component-search-${option.key}`)}`}
                                getOptionValue={(option) => `${option.id}`}
                                isClearable={true}
                                isSearchable={true}
                                placeholder="Seleccione un Tópico"
                                className="basic-single"
                            />
                            )}
                    </div>

                    <div className="col-md-5" style={{ paddingLeft: '0' }}>
                        <div className="card1">

                            {moduleSelected && moduleSelected.key === 'vision' ? (
                                <div className="control">
                                    <Select
                                        styles={customStylesConcern}

                                        onChange={(event) => handleChangeValues(event, 'select')}
                                        className={`basic-single form-control txt-view`}

                                        classNamePrefix="select-concern"
                                        name="concern"
                                        inputId="concern"
                                        value={concernSelected}
                                        //options={listConcerns}
                                        options={listConcernsGroup}
                                        isOptionDisabled={(option) => option.has_vision === false}
                                        getOptionLabel={(option) => `¿${String(option.description || '').trim() || option.name}?`}
                                        getOptionValue={(option) => `${option}`}
                                        isClearable={true}
                                        isSearchable={true}
                                        placeholder={moduleSelected ? `${t('general.component-search-combo')} ${t(`general.component-search-${moduleSelected.key}`)}` : t("generic.component-search-generic")}

                                    />
                                </div>
                            ) : (
                                <input
                                    style={{ height: "50px" }}
                                    type="text"
                                    className="form-control"
                                    placeholder={moduleSelected ? `${t('general.component-search-combo')} ${t(`general.component-search-${moduleSelected.key}`)}` : t("generic.component-search-generic")}
                                    value={searchTextState}
                                    id="searchSerieText"
                                    name="searchSerieText"
                                    onChange={(event) => handleChangeValues(event, 'input')}
                                    onFocus={() => setSearchHelpVisible(true)}
                                    onBlur={() => setSearchHelpVisible(false)}

                                ></input>
                            )}

                        </div>
                    </div>

                    <div className="col-md-1">
                        {/*<button className="btn btn-secondary" onClick={handleGetTechnologies}>
                            <i className="fa fa-search"></i>
                        </button>*/}
                        <button
                            type="submit"
                            disabled={isLoading} // 🚩 BLOQUEO VISUAL
                            className={isLoading ? "btn-loading" : "btn btn-secondary"}
                        >
                            {isLoading ? <i className="fas fa-spinner fa-spin"></i> : <i className="fa fa-search"></i>}
                        </button>
                    </div>

                    <br />

                    <hr />

                </div>
            </form>

            {searchHelpVisible && helpLegendEnabled && moduleSelected?.key !== 'vision' && (
                <p
                    className="search-help-legend"
                    style={{
                        margin: '4px 12px 14px',
                        padding: '10px 14px',
                        background: '#fff',
                        color: '#495057',
                        fontSize: '0.92rem',
                        lineHeight: 1.45,
                        borderRadius: '6px',
                        border: '1px solid rgba(0, 123, 255, 0.18)',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)'
                    }}
                >
                    {t('semanticSearch.help.legend')}
                    {helpPopupEnabled && (
                        <button
                            type="button"
                            className="btn btn-link p-0 ms-2 align-baseline"
                            aria-label={t('semanticSearch.help.open')}
                            onMouseDown={(event) => event.preventDefault()}
                            onClick={() => setSearchHelpOpen(true)}
                        >
                            <i className="fas fa-info-circle" aria-hidden="true"></i>
                        </button>
                    )}
                </p>
            )}

            {searchHelpOpen && helpPopupEnabled && createPortal(
                <div
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="search-help-title"
                    onClick={() => setSearchHelpOpen(false)}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        zIndex: 2000,
                        background: 'rgba(0,0,0,.45)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '24px'
                    }}
                >
                    <div
                        className="search-help-panel"
                        onClick={(event) => event.stopPropagation()}
                        style={{
                            background: '#fff',
                            borderRadius: '8px',
                            maxWidth: '680px',
                            width: '100%',
                            maxHeight: '85vh',
                            overflow: 'auto',
                            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.28)'
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                justifyContent: 'space-between',
                                gap: '16px',
                                padding: '16px 20px',
                                background: '#007bff',
                                color: '#fff',
                                borderRadius: '8px 8px 0 0'
                            }}
                        >
                            <h5 id="search-help-title" style={{ margin: 0, fontSize: '1.15rem', fontWeight: 600, lineHeight: 1.35 }}>
                                {t('semanticSearch.help.title')}
                            </h5>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                aria-label={t('semanticSearch.help.close')}
                                onClick={() => setSearchHelpOpen(false)}
                            ></button>
                        </div>
                        <div className="search-help-body" style={{ padding: '20px 24px 8px', color: '#212529', fontSize: '0.98rem', lineHeight: 1.55 }}>
                            <p>{t('semanticSearch.help.welcome')}</p>
                            <p>{t('semanticSearch.help.difference')}</p>
                            <p style={{ marginBottom: '8px' }}><strong>{t('semanticSearch.help.how')}</strong></p>
                            <ul>
                                <li><strong>{t('semanticSearch.help.ownWordsTitle')}</strong> {t('semanticSearch.help.ownWords')}</li>
                                <li><strong>{t('semanticSearch.help.technicalTitle')}</strong> {t('semanticSearch.help.technical')}</li>
                                <li><strong>{t('semanticSearch.help.casesTitle')}</strong> {t('semanticSearch.help.cases')}</li>
                            </ul>
                            <p>{t('semanticSearch.help.closing')}</p>
                        </div>
                        <div style={{ padding: '4px 24px 20px', textAlign: 'center' }}>
                            <button
                                type="button"
                                className="btn btn-primary"
                                style={{ minWidth: '140px' }}
                                onClick={() => setSearchHelpOpen(false)}
                            >
                                {t('semanticSearch.help.close')}
                            </button>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </div>
    )
}

export default L2SearchTextComponent